// extracted by mini-css-extract-plugin
export default {"purchasedBot":"index-module__purchasedBot___uBaAJ","deleteIcon":"index-module__deleteIcon___wBbnG"};